import React, { forwardRef, useCallback } from 'react';
import { CustomContentProps, SnackbarContent, closeSnackbar } from 'notistack';
import { Typography, Box } from '@mui/material';
import { CoreToastBody } from './core-toast-body.component';
import { CoreToastText } from './core-toast-text.component';
import { CoreToastIcon } from './core-toast-icon.component';
import { CheckCircleIcon, InfoCircleIcon, WarningCircleIcon, ErrorCircleIcon, CloseIcon } from '../../../icons';
import { CoreIconButton } from '../core-button';
import { Colors } from '../../../constants';

export interface CoreToastProps extends CustomContentProps {
	title?: string;
	maxContentWidth?: number | null;
}

const SnackIcons = {
	default: <InfoCircleIcon />,
	info: <InfoCircleIcon />,
	error: <ErrorCircleIcon />,
	success: <CheckCircleIcon />,
	warning: <WarningCircleIcon />,
};

export const CoreToast = forwardRef<HTMLDivElement, CoreToastProps>((props, ref) => {
	const { id, message, variant, title, maxContentWidth } = props;

	const icon = SnackIcons[variant];

	const handleClose = useCallback(() => {
		closeSnackbar(id);
	}, [id]);

	return (
		<SnackbarContent ref={ref} role="alert">
			<CoreToastBody variant={variant} sx={{ maxWidth: maxContentWidth }}>
				<CoreToastIcon variant={variant}>{icon}</CoreToastIcon>
				<CoreToastText variant={variant}>
					{title && (
						<Typography
							sx={{
								fontFamily: 'Montserrat, sans-serif',
								fontWeight: 600,
								fontSize: '15px',
								lineHeight: '21px',
								letterSpacing: '0%',
								color: Colors.white,
							}}
						>
							{title}
						</Typography>
					)}
					{message && (
						<Box
							component="label"
							sx={{
								fontFamily: 'Montserrat, sans-serif',
								fontWeight: title ? 500 : 600,
								fontSize: '15px',
								lineHeight: '21px',
								letterSpacing: '0%',
								color: title ? Colors.white_a80 : Colors.white,
							}}
						>
							{message}
						</Box>
					)}
				</CoreToastText>
				<CoreIconButton
					onClick={handleClose}
					sx={{
						alignSelf: 'flex-start',
						color: Colors.white,
						height: '24px',
						width: '24px',
						padding: 0,
					}}
				>
					<CloseIcon width={18} height={18} />
				</CoreIconButton>
			</CoreToastBody>
		</SnackbarContent>
	);
});
